import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';

import Spacer from 'components/ui/Spacer';
import Select from 'components/ui/SelectField';
import Form from 'components/ui/Form';
import Row from 'components/ui/Row';
import Col from 'components/ui/Col';
import { getUnits, getResidentsOfUnitWithPAPDetails } from 'actions/landlordPropertiesActions';

import { ConfigProvider, Empty as AntEmpty } from 'antd';
import { getTranslatedString } from 'helpers/i18n';

const FullWidthSelect = styled(Select)`
  width: 100%;
`;

const StyledText = styled.p`
  font-size: 14px;
  color: ${colors.CHAR_COUNT};
`;

const Empty = () => (
  <AntEmpty description={getTranslatedString('noData')} image={AntEmpty.PRESENTED_IMAGE_SIMPLE} />
);

const Unit = ({
  values,
  setValues,
  touched,
  errors,
  units,
  getUnits,
  getResidentsOfUnitWithPAPDetails,
  selectedBatch,
  disabled,
}) => {
  useEffect(
    () => {
      if (units.length === 0) {
        getUnits(selectedBatch.property_id);
      }
    },
    [getUnits, units, selectedBatch.property_id]
  );

  const handleUnitChange = value => {
    setValues({
      ...values,
      unit_id: value,
      cotenant_id: undefined,
    });
    getResidentsOfUnitWithPAPDetails(value);
  };

  return (
    <ConfigProvider renderEmpty={Empty} image={Empty.PRESENTED_IMAGE_SIMPLE}>
      <Spacer mb={1}>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label={`${getTranslatedString('landlordPortal.maintenance.tickets.unit')}*`}
              validateStatus={touched.unit_id && errors.unit_id ? 'error' : null}
              help={touched.unit_id && errors.unit_id}
            >
              <FullWidthSelect
                name="unit_id"
                showSearch
                placeholder={getTranslatedString('landlordPortal.maintenance.tickets.select')}
                size="large"
                value={values.unit_id}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={handleUnitChange}
                disabled={disabled}
              >
                {units.map(unit => (
                  <Select.Option value={unit.id} key={unit.id}>
                    {unit.unit_number}
                  </Select.Option>
                ))}
              </FullWidthSelect>
            </Form.Item>
            <StyledText>
              {getTranslatedString('landlordPortal.batch.payments.units.infoText')}
            </StyledText>
          </Col>
        </Row>
      </Spacer>
    </ConfigProvider>
  );
};

const mapStoreToProps = store => ({
  units: store.landlordProperties.units,
});

const mapDispatchToProps = { getUnits, getResidentsOfUnitWithPAPDetails };

export default connect(mapStoreToProps, mapDispatchToProps)(Unit);
